import { Form, FormInstance, Input, Select } from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  DeliveryPointData,
  DeliveryPointResponse,
  MasterDistrictData,
  MasterLocationTypeData,
  MasterProvinceData,
  MasterSubDistrictData,
  MasterTransportData,
  ParkingTransportDistrictType,
  ParkingTransportDistrictTypeResponse,
  ParkingTransportProvinceType,
  ParkingTransportProvinceTypeResponse,
  ParkingTransportType,
  ParkingTransportTypeResponse,
} from "services/interface";
import TextArea from "antd/es/input/TextArea";
import { useGetDeliveryPoint } from "hooks/useShipping";

interface CreateAgentAddressFormProps {
  form: FormInstance;
  masterLocationData: any; //GetMasterLocationResponse;
  masterTransportData: any;
  masterProviceData: any;
  masterDistrictData: any;
  masterSubDistrictData: any;
  setSelectedLocation: any;
  selectedLocation: any;
  setDistrictId: Dispatch<SetStateAction<number>>;
  setProvinceId: Dispatch<SetStateAction<number>>;
  deliveryPointData?: DeliveryPointResponse | undefined;
  masterProviceFreeData?: ParkingTransportProvinceTypeResponse | undefined;
  masterDistrictFreeData?: ParkingTransportDistrictTypeResponse | undefined;
  deliveryFreePoint?: ParkingTransportTypeResponse | undefined;
}

const { Option } = Select;

const CreateAgentAddressForm: FC<CreateAgentAddressFormProps> = ({
  form,
  masterLocationData,
  masterTransportData,
  masterProviceData,
  masterDistrictData,
  masterSubDistrictData,
  selectedLocation,
  setSelectedLocation,
  setDistrictId,
  setProvinceId,
  deliveryPointData,
  masterDistrictFreeData,
  masterProviceFreeData,
  deliveryFreePoint,
}) => {
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);
  const [subDistrict, setSubDistrict] = useState<MasterSubDistrictData[]>([]);
  const [transport, setTransport] = useState<MasterTransportData[]>([]);
  const [location, setLocation] = useState<MasterLocationTypeData[]>([]);
  const [deliveryPoint, setDeliveryPoint] = useState<DeliveryPointData[]>([]);

  const [masterFreeProvince, setMasterFreeProvince] = useState<ParkingTransportProvinceType[]>([]);
  const [masterFreeDistrict, setMasterFreeDistrict] = useState<ParkingTransportDistrictType[]>([]);
  const [masterFreeDeliveryPoint, setMasterFreeDeliveryPoint] = useState<ParkingTransportType[]>([]);

  // const [childrenParking, setChildrenParking] = useState<React.ReactNode[]>([]);
  // const { mutate:ParkingById } = useGetParkingList();

  // // const childrenParking: React.ReactNode[] = [];

  // const getParkingList = (typeId: string) => {
  //   ParkingById(typeId, {
  //     onSuccess: (res) => {
  //       if (res.status === "success") {
  //         const newChildrenTransport = res.data.map((item: any) => (
  //           <Option key={item.key} value={item.key}>
  //             {item.name}
  //           </Option>
  //         ));
  //         setChildrenParking(newChildrenTransport);
  //         // res.data.map((item: any) => {
  //         //   return childrenParking.push(
  //         //     <Option key={item.key} value={item.key}>
  //         //       {item.name}
  //         //     </Option>
  //         //   );
  //         // });
  //       } else {
  //         // message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
  //       }
  //     },
  //     onError: (error) => {
  //       // message.error(`ลบไม่สำเร็จ: ${error.message}`);
  //     },
  //   });
  // }

  useEffect(() => {
    if (masterProviceData) {
      setProvince(masterProviceData);
    }
    if (masterDistrictData) {
      setDistrict(masterDistrictData);
    }
    if (masterSubDistrictData) {
      setSubDistrict(masterSubDistrictData);
    }
    if (masterTransportData) {
      setTransport(masterTransportData);
    }
    if (masterLocationData) {
      setLocation(masterLocationData);
    }

    if (deliveryPointData) {
      setDeliveryPoint(deliveryPointData?.data?.data);
    }

    if (masterProviceFreeData) {
      setMasterFreeProvince(masterProviceFreeData.data);
    }

    if (masterDistrictFreeData) {
      setMasterFreeDistrict(masterDistrictFreeData.data);
    }

    if (deliveryFreePoint) {
      setMasterFreeDeliveryPoint(deliveryFreePoint.data);
    }

  }, [
    masterProviceData,
    masterDistrictData,
    masterSubDistrictData,
    masterTransportData,
    masterLocationData,
    deliveryPointData,
    masterDistrictFreeData,
    masterProviceFreeData,
    deliveryFreePoint,
  ]);

  const childrenDeiveryPoint: React.ReactNode[] = [];
  deliveryPoint?.map((item) => {
    return childrenDeiveryPoint.push(
      <Option key={item.id} value={item.id}>
        {item.delivery_point}
      </Option>
    );
  });

  const childrenTransport: React.ReactNode[] = [];
  transport?.map((item) => {
    return childrenTransport.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenProvince: React.ReactNode[] = [];
  province?.map((item) => {
    return childrenProvince.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenDistrict: React.ReactNode[] = [];
  district?.map((item) => {
    return childrenDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenSubDistrict: React.ReactNode[] = [];
  subDistrict?.map((item) => {
    return childrenSubDistrict.push(
      <Option key={item.id} value={item.id}>
        {item.name_th}
      </Option>
    );
  });

  const childrenLocationType: React.ReactNode[] = [];
  location?.map((item) => {
    return childrenLocationType.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const childrenFreeProvince: React.ReactNode[] = [];
  masterFreeProvince?.map((item) => {
    childrenFreeProvince.push(
      <Option key={item.id} value={item.id.toString()}>
        {item.name_th}
      </Option>
    );
  });

  const childrenFreeDistrict: React.ReactNode[] = [];
  masterFreeDistrict?.map((item) => {
    childrenFreeDistrict.push(
      <Option key={item.district_id} value={item.district_id.toString()}>
        {item.district_name_th}
      </Option>
    );
  });

  const childrenDeriveryFreePoint: React.ReactNode[] = [];
  masterFreeDeliveryPoint?.map((item) => {
    childrenDeriveryFreePoint.push(
      <Option key={item.parking_id} value={item.parking_id.toString()}>
        {item.delivery_point}
      </Option>
    );
  });

  const validatePhoneNumber = (_: any, value: string) => {
    const phoneNumberPattern = /^[0-9]+$/;
    if (!value || value.match(phoneNumberPattern)) {
      return Promise.resolve();
    }
    return Promise.reject("เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น");
  };

  return (
    <FormWrapper>
      <FormItems
        labelAlign="left"
        label="การขนส่งที่ต้องการรับ"
        name="transport"
        rules={[{ required: true, message: "กรุณาเลือกการขนส่งที่ต้องการรับ" }]}
      >
        <Select
          placeholder="การขนส่งที่ต้องการรับ"
          onChange={(value) => {
            form.resetFields();
            const selectedTransport = transport?.find(
              (item) => item.key === value
            );
            if (selectedTransport) {
              setSelectedLocation(selectedTransport?.key);
              form.setFieldsValue({ transport: value });
              // getParkingList(value);
            } else {
              setSelectedLocation("");
            }
          }}
        >
          {childrenTransport}
        </Select>
      </FormItems>

      {/* <FormItems
          labelAlign="left"
          label="เงื่อนไขราคา"    
          name="condition"    
          >
            <Input
                placeholder="เงื่อนไขราคา"
                size="small"
                autoComplete="off"
            />     
          </FormItems> */}

      {selectedLocation === "pick_up_yourself" && (
        <>
          <FormItems
            labelAlign="left"
            label="ชื่อผู้รับสินค้า"
            name="address_name"
            rules={[{ required: true, message: "กรุณากรอกชื่อผู้รับสินค้า" }]}
          >
            <Input
              placeholder="ชื่อผู้รับสินค้า"
              size="small"
              autoComplete="off"
            />
          </FormItems>

          <FormItems
            labelAlign="left"
            label="โทรศัพท์มือถือ"
            name="address_telephone"
            rules={[
              { required: true, message: "กรุณากรอกเบอร์โทรศัพท์มือถือ" },
              { validator: validatePhoneNumber },
            ]}
          >
            <Input
              placeholder="โทรศัพท์มือถือ สำหรับติดต่อผู้รับ"
              size="small"
              autoComplete="off"
            />
          </FormItems>
          <FormItems label="หมายเหตุ" labelAlign="left" name="remark">
            <TextArea placeholder="หมายเหตุ" rows={5} />
          </FormItems>
        </>
      )}

      {(selectedLocation === "post_office" || selectedLocation === "taxi") && (
        <>
          <FormItems
            labelAlign="left"
            label="ชื่อผู้รับสินค้า"
            name="address_name"
            rules={[{ required: true, message: "กรุณากรอกชื่อผู้รับสินค้า" }]}
          >
            <Input
              placeholder="ชื่อผู้รับสินค้า"
              size="small"
              autoComplete="off"
            />
          </FormItems>
          <FormItems
            labelAlign="left"
            label="โทรศัพท์มือถือ"
            name="address_telephone"
            rules={[
              {
                required: true,
                message: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
              },
              { validator: validatePhoneNumber },
            ]}
          >
            <Input
              placeholder="โทรศัพท์มือถือ สำหรับติดต่อผู้รับ"
              size="small"
              autoComplete="off"
            />
          </FormItems>

          <FormItems labelAlign="left" label="บ้านเลขที่/ซอย/ถนน" name="line_1">
            <Input
              placeholder="บ้านเลขที่/ซอย/ถนน"
              size="small"
              autoComplete="off"
            />
          </FormItems>

          <FormItems
            labelAlign="left"
            label="ปลายทางจังหวัด"
            name="province_id_ship"
            rules={[{ required: true, message: "กรุณากรอกปลายทางจังหวัด" }]}
          >
            <Select
              showSearch
              placeholder="จังหวัด"
              optionFilterProp="children"
              onChange={(value) => {
                setProvinceId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({ district_id_ship: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenProvince}
            </Select>
          </FormItems>

          <FormItems
            label="ปลายทางเขต/อำเภอ"
            labelAlign="left"
            name="district_id_ship"
          >
            <Select
              showSearch
              placeholder="ปลายทางเขต/อำเภอ"
              optionFilterProp="children"
              onChange={(value) => {
                setDistrictId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenDistrict}
            </Select>
          </FormItems>
          <FormItems
            label="ปลายแขวง/ตำบล"
            labelAlign="left"
            name="sub_district_id_ship"
          >
            <Select
              showSearch
              placeholder="เลือกปลายแขวง/ตำบล"
              optionFilterProp="children"
              onChange={(value) => {
                subDistrict.map((item) => {
                  if (item.id === value) {
                    form.setFieldsValue({
                      zip_code_ship: item.zip_code,
                    });
                  }
                });
              }}
            >
              {childrenSubDistrict}
            </Select>
          </FormItems>
          <FormItems
            label="รหัสไปรษณีย์ปลายทาง"
            labelAlign="left"
            name="zip_code_ship"
          >
            <Input
              placeholder="รหัสไปรษณีย์ปลายทาง"
              maxLength={5}
              minLength={5}
              autoComplete="off"
            />
          </FormItems>

          <FormItems label="หมายเหตุ" labelAlign="left" name="remark">
            <TextArea placeholder="หมายเหตุ" rows={5} />
          </FormItems>
        </>
      )}

      {(selectedLocation === "transport_bus" ||
        selectedLocation === "manual_transport") && (
        <>
          <FormItems
            labelAlign="left"
            label="ชื่อผู้รับสินค้า"
            name="address_name"
            rules={[{ required: true, message: "กรุณากรอกชื่อผู้รับสินค้า" }]}
          >
            <Input
              placeholder="ชื่อผู้รับสินค้า"
              size="small"
              autoComplete="off"
            />
          </FormItems>
          <FormItems
            labelAlign="left"
            label="โทรศัพท์มือถือ"
            name="address_telephone"
            rules={[
              {
                required: true,
                message: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
              },
              { validator: validatePhoneNumber },
            ]}
          >
            <Input
              placeholder="โทรศัพท์มือถือ สำหรับติดต่อผู้รับ"
              size="small"
              autoComplete="off"
            />
          </FormItems>

          <FormItems
            labelAlign="left"
            label="ปลายทางจังหวัด"
            name="province_id_ship"
            rules={[{ required: true, message: "กรุณากรอกปลายทางจังหวัด" }]}
          >
            <Select
              showSearch
              placeholder="จังหวัด"
              optionFilterProp="children"
              onChange={(value) => {
                setProvinceId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({ district_id_ship: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenProvince}
            </Select>
          </FormItems>

          <FormItems
            label="ปลายทางเขต/อำเภอ"
            labelAlign="left"
            name="district_id_ship"
          >
            <Select
              showSearch
              placeholder="ปลายทางเขต/อำเภอ"
              optionFilterProp="children"
              onChange={(value) => {
                setDistrictId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenDistrict}
            </Select>
          </FormItems>
          <FormItems labelAlign="left" label="จุดส่งสินค้า" name="parking_id"
            //rules={[{ required: true, message: "กรุณาเลือกจุดส่งสินค้า" }]}
          >
            <Select
              showSearch
              placeholder="จุดส่งสินค้า"
              optionFilterProp="children"
            >
              {childrenDeiveryPoint}
            </Select>
          </FormItems>
          <FormItems label="หมายเหตุ" labelAlign="left" name="remark">
            <TextArea placeholder="หมายเหตุ" rows={5} />
          </FormItems>
        </>
      )}

      {selectedLocation === "transport_free" && (
        <>
          <FormItems
            labelAlign="left"
            label="ชื่อผู้รับสินค้า"
            name="address_name"
            rules={[{ required: true, message: "กรุณากรอกชื่อผู้รับสินค้า" }]}
          >
            <Input
              placeholder="ชื่อผู้รับสินค้า"
              size="small"
              autoComplete="off"
            />
          </FormItems>
          <FormItems
            labelAlign="left"
            label="โทรศัพท์มือถือ"
            name="address_telephone"
            rules={[
              {
                required: true,
                message: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
              },
              { validator: validatePhoneNumber },
            ]}
          >
            <Input
              placeholder="โทรศัพท์มือถือ สำหรับติดต่อผู้รับ"
              size="small"
              autoComplete="off"
            />
          </FormItems>

          <FormItems
            labelAlign="left"
            label="ปลายทางจังหวัด"
            name="province_id_ship"
            rules={[{ required: true, message: "กรุณากรอกปลายทางจังหวัด" }]}
          >
            <Select
              showSearch
              placeholder="จังหวัด"
              optionFilterProp="children"
              onChange={(value) => {
                setProvinceId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({ district_id_ship: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenFreeProvince}
            </Select>
          </FormItems>

          <FormItems
            label="ปลายทางเขต/อำเภอ"
            labelAlign="left"
            name="district_id_ship"
          >
            <Select
              showSearch
              placeholder="ปลายทางเขต/อำเภอ"
              optionFilterProp="children"
              onChange={(value) => {
                setDistrictId(value);
                form.setFieldsValue({ parking_id: undefined });
                form.setFieldsValue({
                  sub_district_id_ship: undefined,
                });
                form.setFieldsValue({ zip_code_ship: undefined });
              }}
            >
              {childrenFreeDistrict}
            </Select>
          </FormItems>
          <FormItems labelAlign="left" label="จุดส่งสินค้า" name="parking_id" required
            rules={[{ required: true, message: "กรุณาเลือกจุดส่งสินค้า" }]}
          >
            <Select
              showSearch
              placeholder="จุดส่งสินค้า"
              optionFilterProp="children"
            >
              {childrenDeriveryFreePoint}
            </Select>
          </FormItems>
          <FormItems label="หมายเหตุ" labelAlign="left" name="remark">
            <TextArea placeholder="หมายเหตุ" rows={5} />
          </FormItems>
        </>
      )}
    </FormWrapper>
  );
};

export default CreateAgentAddressForm;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 100%;
`;
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;
